// @flow
import React from 'react';
import { range } from 'lodash';
import { useTranslationNs } from '@helpers/helpers';
import './Skeleton.scss';

// Grey shapes of what is about to appear, so a page keeps its layout while it loads
// instead of flashing blank and then a spinner.

const Busy = ({ className, children }: { className: string, children: any }) => {
  const [_] = useTranslationNs('global');
  return (
    <div className={`skeleton ${className}`} aria-busy="true" aria-label={_('label/loading')}>
      <div aria-hidden="true">{children}</div>
    </div>
  );
};

// A record card of the patient's timeline: author tab, date, a few lines of text
export const SkeletonRecords = ({ count = 3 }: { count?: number }) => (
  <Busy className="skeletonRecords">
    {range(count).map((i) => (
      <div key={i} className="skeletonRecord">
        <span className="skeletonTab" />
        <div className="skeletonRecordTop">
          <span className="skeletonLine w30" />
          <span className="skeletonLine w15" />
        </div>
        <div className="skeletonRecordBody">
          <span className="skeletonLine w90" />
          <span className="skeletonLine w75" />
          <span className="skeletonLine w40" />
        </div>
      </div>
    ))}
  </Busy>
);

// Rows of a list or table (services, payments, receipts)
export const SkeletonRows = ({ count = 3 }: { count?: number }) => (
  <Busy className="skeletonRows">
    {range(count).map((i) => (
      <div key={i} className="skeletonRow">
        <span className="skeletonLine w15" />
        <span className="skeletonLine w40" />
        <span className="skeletonLine w15" />
      </div>
    ))}
  </Busy>
);

// A single value still on its way, such as a balance
export const SkeletonValue = () => {
  const [_] = useTranslationNs('global');
  return <span className="skeleton skeletonLine skeletonValue" aria-label={_('label/loading')} />;
};
